import { Component, ChangeDetectorRef, OnDestroy, OnInit } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-private-space',
  templateUrl: './private-space.component.html',
  styleUrls: ['./private-space.component.css']
})
export class PrivateSpaceComponent implements OnInit {
  collapsedNav: boolean;
  mobileQuery: MediaQueryList;

  private _mobileQueryListener: () => void;

  recievedProperty: any;
  constructor(
    changeDetectorRef: ChangeDetectorRef,
     media: MediaMatcher,
     private router: Router,
     private route: ActivatedRoute,) {
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {

      console.log("recieved property: ", params);
      this.recievedProperty = params;

    });
  }


  exit() {
    this.router.navigate(["/home"]);
  }

}
